import { WorkflowIDocCoreErrorDTO } from 'src/app/shared/interfaces/workflows/workflow-idoc-core-error-dto.interface';
import { NatureCustomData } from '../iCourrier/custom-datas/nature-custom-data';
import { MailDetailsTakeOverDto } from '../mails/mail-details-dto.';
import { MailDestinataireBaseContactInput } from '../iCourrier/post/mail-destinataire-base-contact-input';
import { WorkflowInstance } from '../workflows/workflow-instance';
import { LastStatusTransition } from '../iCourrier/scans/last-status-transition';

export class MailCreateScanInput {
  public scanId: number; // id of the scan
  public linkMailId?: number; // the id of the mail will be linked to the new mail
  // Same as MailInsert
  public id?: number;
  public serviceProprietaireId: number;
  public typeEntrantSortant: string;
  public natureId?: number;
  public sourceId?: number;
  public refExpediteur?: string;
  public expediteurLibre?: string;
  public expediteurId?: number;
  public expediteurIdiAdmin?: number;

  public objet?: string;
  public remarques?: string;
  public dateDocument?: string;
  public dateEcheance?: string;
  public dateEntree?: string;
  public classementId?: number;
  public classeurId?: number;
  public chemiseId?: number;
  public dossierId?: number;
  public refRecommande?: string;
  public projetId?: number;
  public confidentiel?: boolean;
  public datePostale?: string;
  public boiteArchive?: string;
  public statutId?: number;
  public autoDistributionbUsers?: MailDestinataireBaseContactInput[];
  public autoDistributionServices?: number[];
  public lastStatusTransition?: LastStatusTransition;
  public statusGlobalName?: string;
  public statusGlobalBackground?: string;
  public statusGlobalColor?: string;
  public workflowStartError: WorkflowIDocCoreErrorDTO;
  public workflowStartFailed: boolean;
  public workflowStartDefinitionId: string;
  public workflowId: string;
  public workflowStartId: string;

  public classementLabel?: string;
  public classeurLabel?: string;
  public chemiseLabel?: string;
  public version?;
  public natureCustomDatas: NatureCustomData[];

  public CentreNumerisationId?: number;
  public DestinataireContactId?: number;
  public FileDescription?: string;
  public Indexes?: string;
  public ScanGuid?: string;
  public NatureCustomDatas?;
  public bacLabelForInfos?: string;
  public bacId?;
  public workflowForInfos?: WorkflowInstance;
  public priseEnChargeInfo?: MailDetailsTakeOverDto;
}
